import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error module not typed

import { getMessageSendFailure, getConnectedAccountAddress
// @ts-expect-error module not typed
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
// @ts-expect-error module not typed
import { isCommonMessageFormat } from 'conversations-message-history/common-message-format/operators/cmfComparators';
import * as publishingErrorTypes from 'conversations-message-history/publishing/constants/publishingErrorTypes';
import { getGenericChannelIdForMessage } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { GMAIL, HUBSPOT_HOSTED, OUTLOOK } from 'conversations-message-history/publishing/constants/emailClientTypes';
import { WHATSAPP_GENERIC_CHANNEL_ID } from 'conversations-message-history/common-message-format/constants/genericChannelIds';
import { jsx as _jsx } from "react/jsx-runtime";
const getErrorType = message => {
  const sendFailure = getMessageSendFailure(message);
  const errorType = sendFailure && sendFailure.get('errorMessage');
  return errorType in publishingErrorTypes ? errorType : 'DEFAULT';
};
const getRateLimitErrorClient = (message, connectedAccounts) => {
  let emailAccountType;
  if (isCommonMessageFormat(message) && connectedAccounts.size !== 0) {
    const connectedAccount = connectedAccounts.find(account => account.email === getConnectedAccountAddress(message));
    emailAccountType = connectedAccount && connectedAccount.get('emailAccountType');
  }
  return emailAccountType;
};
export const getEmailClientName = (message, connectedAccounts) => {
  const clientType = getRateLimitErrorClient(message, connectedAccounts);
  switch (clientType) {
    case GMAIL:
      return 'Gmail';
    case HUBSPOT_HOSTED:
      return 'HubSpot';
    case OUTLOOK:
      return 'Outlook';
    default:
      return 'email client';
  }
};
export const getPublishFailedErrorPath = (message, options) => {
  const {
    subscriptionType
  } = options;
  const errorType = getErrorType(message);
  const genericChannelId = getGenericChannelIdForMessage(message);
  switch (errorType) {
    case publishingErrorTypes.EMAIL_RATE_LIMITED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.EMAIL_RATE_LIMITED.description",
        options: options
      });
    case publishingErrorTypes.EMAIL_ATTACHMENT_PROCESSING_FAILURE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.EMAIL_ATTACHMENT_PROCESSING_FAILURE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_BODY_TOO_LONG:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_BODY_TOO_LONG.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_TEMPLATE_NOT_APPROVED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_TEMPLATE_NOT_APPROVED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_RECIPIENT_INCAPABLE_OF_RECEIVING_MESSAGE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_INCAPABLE_OF_RECEIVING_MESSAGE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_TEMPLATE_MAX_BODY_LENGTH_EXCEEDED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_TEMPLATE_MAX_BODY_LENGTH_EXCEEDED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_SENT_INVALID_PARAMETERS_FOR_TEMPLATED_MESSAGE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_SENT_INVALID_PARAMETERS_FOR_TEMPLATED_MESSAGE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_ACCOUNT_LOCKED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_ACCOUNT_LOCKED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_A2P_10DLC_CAMPAIGN_SUSPENDED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_A2P_10DLC_CAMPAIGN_SUSPENDED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_MEDIA_FILE_EMPTY:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_MEDIA_FILE_EMPTY.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_MEDIA_FILE_TOO_LARGE:
      {
        return genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_MEDIA_FILE_TOO_LARGE.WHATS_APP",
          options: options
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_MEDIA_FILE_TOO_LARGE.description"
        });
      }
    case publishingErrorTypes.SHORT_MESSAGES_SENDING_PHONE_NUMBER_MISCONFIGURED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_SENDING_PHONE_NUMBER_MISCONFIGURED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_RECIPIENT_NOT_ENGAGED_IN_SESSION:
      return genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_NOT_ENGAGED_IN_SESSION.WHATS_APP"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_NOT_ENGAGED_IN_SESSION.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_RECIPIENT_NOT_OPTED_IN:
      {
        if (genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID) {
          return subscriptionType.includes('TRANSACTIONAL_WHATSAPP') ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_NOT_OPTED_IN.WHATSAPP_TRANSACTIONAL"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_NOT_OPTED_IN.WHATSAPP_MARKETING"
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_NOT_OPTED_IN.description"
        });
      }
    case publishingErrorTypes.SHORT_MESSAGES_RECIPIENT_OPTED_OUT:
      {
        if (genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID) {
          return subscriptionType.includes('TRANSACTIONAL_WHATSAPP') ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_OPTED_OUT.WHATSAPP_TRANSACTIONAL"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_OPTED_OUT.WHATSAPP_MARKETING"
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_OPTED_OUT.description"
        });
      }
    case publishingErrorTypes.SHORT_MESSAGES_RECIPIENT_DOES_NOT_USE_WHATSAPP:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_RECIPIENT_DOES_NOT_USE_WHATSAPP.description"
      });
    case publishingErrorTypes.A2P_10DLC_CAMPAIGN_SUSPENDED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.A2P_10DLC_CAMPAIGN_SUSPENDED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_LIMITED:
      return genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_LIMITED.WHATS_APP"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_LIMITED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_MISSING_SCOPE:
      return genericChannelId === WHATSAPP_GENERIC_CHANNEL_ID ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_MISSING_SCOPE.WHATS_APP"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_MISSING_SCOPE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_SENDING_PHONE_NUMBER_SAME_AS_RECIPIENT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_SENDING_PHONE_NUMBER_SAME_AS_RECIPIENT.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_TEMPLATE_NOT_USABLE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_TEMPLATE_NOT_USABLE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_UNRENDERABLE_TEMPLATE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_UNRENDERABLE_TEMPLATE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_QUALITY_RATE_LIMIT_EXCEEDED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_QUALITY_RATE_LIMIT_EXCEEDED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_TEMPLATE_MAX_HEADER_LENGTH_EXCEEDED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_TEMPLATE_MAX_HEADER_LENGTH_EXCEEDED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_UNSUPPORTED_MEDIA_TYPE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_UNSUPPORTED_MEDIA_TYPE.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_AGENT_SERVER_ERROR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_AGENT_SERVER_ERROR.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_AGENT_TIMEOUT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_AGENT_TIMEOUT.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_UNREACHABLE_NUMBER:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_UNREACHABLE_NUMBER.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_UNACCEPTABLE_PHONE_NUMBER:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_UNACCEPTABLE_PHONE_NUMBER.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_MESSAGE_BLOCKED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_MESSAGE_BLOCKED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_NOT_A_MOBILE_NUMBER:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_NOT_A_MOBILE_NUMBER.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_CARRIER_DAILY_LIMIT_REACHED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_CARRIER_DAILY_LIMIT_REACHED.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_AGENT_UNKNOWN_DELIVERY_ERROR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_AGENT_UNKNOWN_DELIVERY_ERROR.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_MESSAGE_NOT_DELIVERED_TO_MAINTAIN_HEALTHY_ECOSYSTEM:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_MESSAGE_NOT_DELIVERED_TO_MAINTAIN_HEALTHY_ECOSYSTEM.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_RECIPIENT_PART_OF_AN_EXPERIMENT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_RECIPIENT_PART_OF_AN_EXPERIMENT.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_WHATSAPP_VIRTUAL_SENDING_PHONE_NUMBER_AND_DISPLAY_NAME_NOT_APPROVED_YET:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_WHATSAPP_VIRTUAL_SENDING_PHONE_NUMBER_AND_DISPLAY_NAME_NOT_APPROVED_YET.description"
      });
    case publishingErrorTypes.SHORT_MESSAGES_SMS_RECIPIENT_IS_A_LANDLINE:
    case publishingErrorTypes.SHORT_MESSAGES_SMS_RECIPIENT_PHONE_NUMBER_TYPE_IS_NOT_SENDABLE:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.SHORT_MESSAGES_SMS_RECIPIENT_IS_A_LANDLINE.description"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-message-history.status.publishing.PUBLISH_FAILED.DEFAULT"
      });
  }
};